export const TrackingEvents = {
  browseContent: 'browse_content',
  viewFlyerSet: 'view_flyer_set',
  viewFlyerDetails: 'view_flyer_details',
  saveFlyer: 'save_flyer',
  unsaveFlyer: 'unsave_flyer',
  viewSavedFlyers: 'view_saved_flyers',
  sortSavedFlyers: 'sort_saved_flyers',
  sortExploreFlyers: 'sort_explore_flyers',
  shareFlyer: 'share_flyer',
  learnMore: 'learn_more',
  contact: 'contact',
  completeFlyerForm: 'complete_flyer_form',
  export: 'export',
  filterFlyerSet: 'filter_flyer_set',
  search: 'search',
  searchFlyer: 'search_flyers',
  receiveNotification: 'receive_notification',
  viewAccessibleFlyer: 'view_accessible_flyer',
  translate: 'translate',
};

export const EventDetails = {
  browseContent: (type: string) => `browse_${type}_content`,
  browseContentPage: (page: string, type: string) => `browse_${page}_${type}_content`,
  viewFlyerSet: (type: string, category?: string) => `view_flyer_set_${type}${category ? `_${category.toLowerCase()}` :''}`,
  viewFlyerDetails: (type: string) => `view_flyer_details_${type}`,
  saveFlyer: (context: string) => `save_flyer_${context}`,
  unsaveFlyer: (context: string) => `unsave_flyer_${context}`,
  shareFlyer: (platform: string) => `share_flyer_${platform}`,
  completeFlyerForm: (action: string) => `complete_flyer_form_${action}`,
  filterFlyerSet: (filter: string) => `filter_flyer_set_${filter}`,
  contact: (method: string) => `contact_${method}`,
  download: 'download',
  print: 'print',
  viewSavedFlyers: 'view_saved_flyers',
  sortSavedFlyers: 'sort_saved_flyers',
  learnMore: 'learn_more',
  search: (type: string) => `search_${type}_flyers`,
  emailNotification: 'email_notification',
  translateFlyerText: 'translate_flyer_text',
};

export const TrackingStage = {
  discovery: 'discovery',
  consideration: 'consideration',
  commitment: 'commitment',
  connection: 'connection'
};
